import {
  SiReact, SiHtml5, SiCss3, SiJavascript, SiTailwindcss, SiTypescript,
  SiNextdotjs, SiVuedotjs,
  SiNodedotjs, SiExpress, SiMongodb, SiMysql, SiLaravel, SiDjango, SiPython,
  SiPostgresql, SiPrisma, SiRedis,
  SiGit, SiGithub, SiFirebase,  SiJest,
} from 'react-icons/si';
import { VscCode } from "react-icons/vsc";

export const frontendSkills = [
  { id: 1, title: 'React', icon: <SiReact className="text-[#61DAFB]" /> },
  { id: 2, title: 'Next.js', icon: <SiNextdotjs className="text-white" /> },
  { id: 3, title: 'TypeScript', icon: <SiTypescript className="text-[#3178C6]" /> },
  { id: 4, title: 'JavaScript', icon: <SiJavascript className="text-[#F7DF1E]" /> },
  { id: 5, title: 'Tailwind CSS', icon: <SiTailwindcss className="text-[#06B6D4]" /> },
  { id: 6, title: 'HTML5', icon: <SiHtml5 className="text-[#E34F26]" /> },
  { id: 7, title: 'CSS3', icon: <SiCss3 className="text-[#1572B6]" /> },
  { id: 8, title: 'Vue.js', icon: <SiVuedotjs className="text-[#4FC08D]" /> },
];

export const backendSkills = [
  { id: 9, title: 'Node.js', icon: <SiNodedotjs className="text-[#339933]" /> },
  { id: 10, title: 'Express', icon: <SiExpress className="text-[#ffffff]" /> },
  { id: 11, title: 'Python', icon: <SiPython className="text-[#3776AB]" /> },
  { id: 12, title: 'Django', icon: <SiDjango className="text-[#092E20]" /> },
  { id: 13, title: 'Laravel', icon: <SiLaravel className="text-[#FF2D20]" /> },
  { id: 14, title: 'PostgreSQL', icon: <SiPostgresql className="text-[#4169E1]" /> },
  { id: 15, title: 'MongoDB', icon: <SiMongodb className="text-[#47A248]" /> },
  { id: 16, title: 'MySQL', icon: <SiMysql className="text-[#4479A1]" /> },
  { id: 17, title: 'Prisma', icon: <SiPrisma className="text-[#2D3748]" /> },
  // { id: 18, title: 'GraphQL', icon: <SiGraphql className="text-[#E10098]" /> },
  { id: 19, title: 'Redis', icon: <SiRedis className="text-[#DC382D]" /> },
  // { id: 20, title: 'Rust', icon: <SiRust className="text-[#ffffff]" /> },
  // { id: 21, title: 'Go', icon: <SiGo className="text-[#00ADD8]" /> },
];

export const tools = [
  { id: 22, title: 'Git', icon: <SiGit className="text-[#F05032]" /> },
  { id: 23, title: 'GitHub', icon: <SiGithub className="text-[#ffffff]" /> },
  // { id: 24, title: 'Docker', icon: <SiDocker className="text-[#2496ED]" /> },
  // { id: 25, title: 'Kubernetes', icon: <SiKubernetes className="text-[#326CE5]" /> },
  { id: 26, title: 'Firebase', icon: <SiFirebase className="text-[#FFCA28]" /> },
  { id: 27, title: 'Jest', icon: <SiJest className="text-[#C21325]" /> },
  // { id: 28, title: 'Figma', icon: <SiFigma className="text-[#F24E1E]" /> },
  { id: 29, title: 'VS Code', icon: <VscCode className="text-[#007ACC]" /> },
  // { id: 30, title: 'Terraform', icon: <SiTerraform className="text-[#7B42BC]" /> },
];
